<div class="d-flex" aria-label="Actions">
    <button type="button" class="icon-btn fill-iconDefault contextMenuButton" (click)="contextMenuClick($event)"
            aria-label="More actions" cvLocalizedAttrs="aria-label" langSection="Dashboards_Landing" langKey="More_Actions">
        <svg [ngClass]="config.isCxOne ? 'icon-20' : 'icon-20 fill-hover-blue'">
            <use href="../App_Themes/clearview-default/icons/utility/more.svg#more"></use>
        </svg>
    </button>
</div>
